// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"dd00f0ca","349":"d46f6a36","554":"2277c095","687":"1d758d0c","813":"39d0f87d","963":"4d17d3a3","989":"bd6a5728"}[chunkId] + ".chunk.js";
};